import React, { useCallback, useEffect, useState } from "react";

interface ImageDimensions {
  width: number;
  height: number;
}

interface ImageLoaderState {
  isLoading: boolean;
  hasError: boolean;
  dimensions: ImageDimensions | null;
}

interface ImageLoaderReturn extends ImageLoaderState {
  handleLoad: (event: React.SyntheticEvent<HTMLImageElement>) => void;
  handleError: () => void;
}

export function useImageDimensions(src: string): ImageLoaderReturn {
  const [state, setState] = useState<ImageLoaderState>({
    isLoading: true,
    hasError: false,
    dimensions: null,
  });

  const handleLoad = useCallback(
    (event: React.SyntheticEvent<HTMLImageElement>) => {
      const img = event.currentTarget;
      setState({
        isLoading: false,
        hasError: false,
        dimensions: {
          width: img.naturalWidth,
          height: img.naturalHeight,
        },
      });
    },
    []
  );

  const handleError = useCallback(() => {
    setState((prevState) => ({
      ...prevState,
      isLoading: false,
      hasError: true,
    }));
  }, []);

  return {
    ...state,
    handleLoad,
    handleError,
  };
}
